import PropTypes, {InferProps} from "prop-types";
import {profileList, usePrincipal, useProfile} from "@betrue/front/services";
import {useEffect, useState} from "react";
import {ProfileListView} from "./profile-list.view";
import {Profile, Role, Scope, Skill} from "@betrue/shared/interfaces";

export const ProfileListPropsTypes = {
  noProfilesLabel: PropTypes.string

}
export type ProfileListProps = InferProps<typeof ProfileListPropsTypes>

export const ProfileList = (props: ProfileListProps) => {

  const [principal] = usePrincipal()
  const [profiles, {getAllProfiles}] = useProfile<Profile[]>(profileList)
  const [completedOnlyProfiles, setCompletedOnlyProfiles] = useState(false)
  const [ratingFilter, setRatingFilter] = useState<Profile['rating']>(0)

  const [filterTerm, setFilterTerm] = useState<string>()
  const [filteredProfiles, setFilteredProfiles] = useState<Profile[]>([])
  const [skillFilterMap, setSkillFilterMap] = useState(undefined)
  const [availableSkills, setAvailableSkills] = useState<Skill[]>([])

  const filterProfiles = (completedOnly, profiles, skillFilterMap) => {
    if (profiles) {
      let result = []
      if (completedOnly) {

        result = profiles.filter(p => p.completion > 80)
      } else {
        result = profiles
      }

      if (filterTerm) {
        result = result.filter(p => {
            return (p.person.firstName.toLowerCase().indexOf(filterTerm.toLowerCase()) >= 0) ||
              (p.person.lastName.toLowerCase().indexOf(filterTerm.toLowerCase()) >= 0) ||
              (p.job?.label?.toLowerCase()?.indexOf(filterTerm.toLowerCase()) >= 0) ||
              (p.skills.filter(ps => ps.skill.label.toLowerCase().indexOf(filterTerm.toLowerCase()) >= 0).length > 0)
          }
        )
      }
      if(ratingFilter || ratingFilter === 0 ){
        result = result.filter(p => {
          const rating = p.rating || p.rating ===0 ?  p.rating:  3
          return  rating  >= ratingFilter
        })
      }
      if (skillFilterMap && Object.keys(skillFilterMap).length > 0) {

        result = result.filter(p => {
          return p.skills.filter(s => skillFilterMap[s.skill.key]).length > 0
        })
      }
      return result
    } else {
      return profiles
    }
  }


  const handleAddSkill = skill => {
    setSkillFilterMap(skillFilterMap ? {...skillFilterMap, [skill.key]: skill} : {[skill.key]: skill})
  }

  const handleRemoveSkill = skill => {
    delete skillFilterMap[skill.key]
    setSkillFilterMap({...skillFilterMap})
  }


  const handleOnlyCompleted = state => {
    setCompletedOnlyProfiles(state)
  }

  const handleSearchTerm = term => {
    setFilterTerm(term)
  }

  const handleRatingFilterChange = (newValue) => {
    setRatingFilter(newValue)
  }

  useEffect(() => {
    if (profiles) {
      setFilteredProfiles(filterProfiles(completedOnlyProfiles, profiles, skillFilterMap))
    }
  }, [completedOnlyProfiles, profiles, filterTerm, skillFilterMap,ratingFilter])


  useEffect(() => {
    if (profiles) {
      const skillsMap = {}
      profiles.forEach(p => {
        p.skills.forEach((s) => {
          skillsMap[s.skill.key] = s
        })
      })
      const skills = []
      for (const key in skillsMap) {
        skills.push(skillsMap[key].skill)
      }
      setAvailableSkills(skills)
    }
  }, [profiles])
  useEffect(() => {
    getAllProfiles()
  }, [])


  if (!profiles || !principal) return (<></>)

  return (<ProfileListView {...props} profiles={filteredProfiles}
                           searchTerm={filterTerm}
                           onRatingFilterChange={handleRatingFilterChange}
                           showRating={principal.scope === Scope.EMPLOYEE && principal.role === Role.ADMIN}
                           availableSkills={availableSkills}
                           onFilter={handleSearchTerm}
                           filterSkillMap={skillFilterMap}
                           onCompletedOnlyChange={handleOnlyCompleted}
                           onAddSkill={handleAddSkill}
                           onRemoveSkill={handleRemoveSkill}
                           completedOnly={completedOnlyProfiles}/>);
}

ProfileList.propTypes = ProfileListPropsTypes
